export const nutritional_info = [
  // { title: `Uom (Description)`, value: "UoM" },
  { title: "mg(Miligrams)", value: "mg" },
  { title: "g(Grams)", value: "g" },
];

export const DistanceData = [
  { title: "No Limit", value: 10000, data: "No Limit" },
  { title: "15 kms", value: 15, data: "15 kms" },
  { title: "10 kms", value: 10, data: "10 kms" },
  { title: "5 kms", value: 5, data: "5 kms" },
  { title: "2 kms", value: 2, data: "2 kms" },
];
export const delivery_options = [
  { title: "Self Delivery", value: 1,data: "Self Delivery",},
  { title: "Dunzo Delivery", value: 2,data: "Dunzo Delivery"},
];

export const CutOffTimeData = [
  { title: "0 Minute", value: 0, data: "0 Minute" },
  { title: "5 Minute", value: 5, data: "5 Minute" },
  { title: "10 Minute", value: 10, data: "10 Minute" },
  { title: "15 Minute", value: 15, data: "15 Minute" },
  { title: "20 Minute", value: 20, data: "20 Minute" },
  { title: "25 Minute", value: 25, data: "25 Minute" },
  { title: "30 Minute", value: 30, data: "30 Minute" },
];

export const AutoCancelData = [
  { title: "No Limit", value: 1000, data: "No Limit" },
  { title: "50 kms", value: 50, data: "50 kms" },
  { title: "30 kms", value: 30, data: "30 kms" },
  { title: "20 kms", value: 20, data: "20 kms" },
  { title: "1 kms", value: 1, data: "1 kms" },
];

export const OrderTimeSlots = [
  { title: "0 Minute", value: 0, data: "0 Minute" },
  { title: "5 Minute", value: 5, data: "5 Minute" },
  { title: "10 Minute", value: 10, data: "10 Minute" },
  { title: "15 Minute", value: 15, data: "15 Minute" },
  { title: "20 Minute", value: 20, data: "20 Minute" },
  { title: "25 Minute", value: 25, data: "25 Minute" },
  { title: "30 Minute", value: 30, data: "30 Minute" },
];

export const MinimumLeadTime = [
  { title: "0 Minute", value: 0, data: "0 Minute" },
  { title: "5 Minute", value: 5, data: "5 Minute" },
  { title: "10 Minute", value: 10, data: "10 Minute" },
  { title: "15 Minute", value: 15, data: "15 Minute" },
  { title: "20 Minute", value: 20, data: "20 Minute" },
  { title: "25 Minute", value: 25, data: "25 Minute" },
  { title: "30 Minute", value: 30, data: "30 Minute" },
];

export const AddMoneyReason = [
  { title: "Cashback", value: "Cashback" },
  { title: "Refund", value: "Refund" },
  {
    title: "Inconvenience caused to the user",
    value: "Inconvenience caused to the user",
  },
  { title: "Other", value: "Other" },
];

export const RemoveMoneyReason = [
  {
    title: "Payment Due from Ordering /Events request",
    value: "Payment Due from Ordering /Events request",
  },
  {
    title: "Excess refund amount",
    value: "Excess refund amount",
  },
  { title: "Other", value: "Other" },
];

export const AddFlagReason = [
  {
    title: "Exceeded 3 cancellations within a week",
    value: "Exceeded 3 cancellations within a week",
  },
  {
    title: "Customer complaints and bad reviews about the business",
    value: "Customer complaints and bad reviews about the business",
  },
  {
    title: "Violations of policies ",
    value: "Violations of policies ",
  },
  {
    title: "Other",
    value: "Other",
  },
];

export const Gender = [
  { title: "MALE", value: 0, data: "MALE" },
  { title: "FEMALE", value: 5, data: "FEMALE" },
  { title: "OTHER", value: 10, data: "OTHER" },
 
];